import { render, staticRenderFns } from "./domainSettingItem2.vue?vue&type=template&id=5335f584&scoped=true&"
import script from "./domainSettingItem2.vue?vue&type=script&lang=js&"
export * from "./domainSettingItem2.vue?vue&type=script&lang=js&"
import style0 from "./domainSettingItem2.vue?vue&type=style&index=0&id=5335f584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335f584",
  null
  
)

export default component.exports